// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsProposedDetailsGridItemStyles } from "@awc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { css } from "styled-components";

rfqQuoteDetailsProposedDetailsGridItemStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingContainer = {
    css: css`
        max-width: 120px;
    `,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingText = {
    size: 12,
    weight: "normal",
    css: css`
        line-height: 13px;
        text-transform: capitalize;
        padding: 0;
    `,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.productPrice = {
    priceLabelText: {
        size: 12,
        weight: "normal",
        css: css`
            line-height: 13px;
            text-transform: capitalize;
            padding: 0;
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 5px;
        `,
    },
};

rfqQuoteDetailsProposedDetailsGridItemStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingStyles = {
    row: {
        mergeCss: true,
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            border: none;
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: 18px;
            padding: 0 8px 0 0;
            vertical-align: top;
            display: flex;
            align-items: baseline;
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: 18px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceWithoutVatCell: {
        css: css`
            border: none;
            height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingContainer = {
    css: css`
        max-width: 120px;
    `,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.cartLineContainerStyles = {
    qty: {
        css: css`
            flex-direction: column;
        `,
    },
};

rfqQuoteDetailsProposedDetailsGridItemStyles.notesFullWidthGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.costCodeGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
        &:empty {
            display: none;
        }
    `,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.qtyOrderedField = {
    wrapper: {
        css: css`
            &:not([class^="FormFieldLabel"]) {
                @media print {
                    border: none;
                }
            }
        `,
    },
    editableQuantityTextField: {
        mergeCss: true,
        cssOverrides: {
            inputSelect: css`
                @media print {
                    box-shadow: none;
                    font-size: 16px;
                    line-height: 17px;
                    font-weight: ${fontConfig.weight.bold};
                    text-align: left;
                }
            `,
            formField: css`
                @media print {
                    label {
                        font-size: 14px;
                        line-height: 16px;
                    }
                }
            `,
        },
    },
};

rfqQuoteDetailsProposedDetailsGridItemStyles.notesTextArea = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            @media print {
                && textarea {
                    border: none;
                    box-shadow: none;
                    padding: 0px;
                    resize: none;
                }
            }
        `,
        formField: css`
            & label {
                display: none;
                @media print {
                    display: block;
                }
            }
        `,
    },
};
